// shopperInfo (get, editPreferences, editInfo, tokene
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import utils from './utils'

const status = utils.initStatus([
	'getStatistics',
	'getBusinessInfo',
	'updateBusinessInfo',
	'getLocations',
	'updateDefaultLocation',
	'getCounts',
	'getPaymentLink',
	'setPaymentLink',
	'sendFeedback',
])

const initialState = {
	businessInfo: {},

	counts: {
		ordersCount: 'none',
		itemsCount: 'none',
		offersCount: 'none',
		pendingItemsCount: 'none',
		pendingOffersCount: 'none',
	},
	bankingCompleted: null,

	paymentLink: '',

	locations: [],
	statistics: {},

	status,
}

export const getStatistics = createAsyncThunk('info/getStatistics', async (params, thunkAPI) => {
	try {
		const { currBranch, token } = utils.getAuth(thunkAPI.getState())
		if (!token)
			return utils.rejectWithValue(thunkAPI, null, { logout: true, message: 'Null token' })

		const res = await axios.get(`/merchant/stats/${currBranch}`, {
			headers: { Authorization: `Bearer ${token}` },
			params,
		})

		if (res.status == 200) {
			return res.data
		}
		return utils.rejectWithValue(thunkAPI, null, {
			message: res.data.message,
			status: res.status,
		})
	} catch (err) {
		return utils.rejectWithValue(thunkAPI, err)
	}
})

export const getBusinessInfo = createAsyncThunk(
	'info/getBusinessInfo',
	async (params, thunkAPI) => {
		try {
			const { currBranch, token } = utils.getAuth(thunkAPI.getState())
			if (!token)
				return utils.rejectWithValue(thunkAPI, null, {
					logout: true,
					message: 'Null token',
				})

			const res = await axios.get(`/merchant/details/location/${params}/${currBranch}`, {
				headers: { Authorization: `Bearer ${token}` },
			})

			if (res.status == 200) {
				return res.data
			}
			return utils.rejectWithValue(thunkAPI, null, {
				message: res.data.message,
				status: res.status,
			})
		} catch (err) {
			return utils.rejectWithValue(thunkAPI, err)
		}
	}
)
export const getLocations = createAsyncThunk('info/getLocations', async (params, thunkAPI) => {
	try {
		const { currBranch, token } = utils.getAuth(thunkAPI.getState())
		if (!token)
			return utils.rejectWithValue(thunkAPI, null, { logout: true, message: 'Null token' })

		const res = await axios.get(`merchant/list/locations/`, {
			headers: { Authorization: `Bearer ${token}` },
			// params: type,
		})

		if (res.status == 200) {
			return res.data
		}
		return utils.rejectWithValue(thunkAPI, null, {
			message: res.data.message,
			status: res.status,
		})
	} catch (err) {
		return utils.rejectWithValue(thunkAPI, err)
	}
})

export const updateDefaultLocation = createAsyncThunk(
	'info/updateDefaultLocation',
	async (location, thunkAPI) => {
		try {
			const { token } = utils.getAuth(thunkAPI.getState())
			if (!token)
				return utils.rejectWithValue(thunkAPI, null, {
					logout: true,
					message: 'Null token',
				})

			const res = await axios.put(`/merchant/update/location`, location, {
				headers: { Authorization: `Bearer ${token}` },
			})

			if (res.status == 200) {
				return res.data
			}
			return utils.rejectWithValue(thunkAPI, null, {
				message: res.data.message,
				status: res.status,
			})
		} catch (err) {
			return utils.rejectWithValue(thunkAPI, err)
		}
	}
)
export const getCounts = createAsyncThunk('info/getCounts', async (params, thunkAPI) => {
	try {
		const { currBranch, token } = utils.getAuth(thunkAPI.getState())
		if (!token)
			return utils.rejectWithValue(thunkAPI, null, { logout: true, message: 'Null token' })

		const res = await axios.get(`/merchant/list/counts/${currBranch}?${params}`, {
			headers: { Authorization: `Bearer ${token}` },
		})

		if (res.status == 200) {
			return res.data
		}
		return utils.rejectWithValue(thunkAPI, null, {
			message: res.data.message,
			status: res.status,
		})
	} catch (err) {
		return utils.rejectWithValue(thunkAPI, err)
	}
})

export const getPaymentLink = createAsyncThunk('info/getPaymentLink', async (params, thunkAPI) => {
	try {
		const { currBranch, token } = utils.getAuth(thunkAPI.getState())
		if (!token)
			return utils.rejectWithValue(thunkAPI, null, { logout: true, message: 'Null token' })

		const res = await axios.get(`/merchant/payment/get/link/${currBranch}`, {
			headers: { Authorization: `Bearer ${token}` },
		})

		if (res.status == 200) {
			return res.data
		}
		return utils.rejectWithValue(thunkAPI, null, {
			message: res.data.message,
			status: res.status,
		})
	} catch (err) {
		return utils.rejectWithValue(thunkAPI, err)
	}
})

export const setPaymentLink = createAsyncThunk('info/setPaymentLink', async (params, thunkAPI) => {
	try {
		const { currBranch, token } = utils.getAuth(thunkAPI.getState())
		if (!token)
			return utils.rejectWithValue(thunkAPI, null, { logout: true, message: 'Null token' })

		const res = await axios.get(`/merchant/payment/set/link/${currBranch}`, {
			headers: { Authorization: `Bearer ${token}` },
		})

		if (res.status == 200) {
			thunkAPI.dispatch(getPaymentLink())
			return res.data
		}
		return utils.rejectWithValue(thunkAPI, null, {
			message: res.data.message,
			status: res.status,
		})
	} catch (err) {
		return utils.rejectWithValue(thunkAPI, err)
	}
})

export const updateBusinessInfo = createAsyncThunk(
	'info/updateBusinessInfo',
	async ({ fieldset, data, signupToken, merchantId, callback }, thunkAPI) => {
		try {
			const { currBranch, token } = utils.getAuth(thunkAPI.getState())
			if (!token && !signupToken)
				return utils.rejectWithValue(thunkAPI, null, {
					logout: true,
					message: 'Null token',
				})

			const res = await axios.post(
				`/merchant/update/store/${fieldset}`,
				{ ...data, merchantId: merchantId || currBranch },
				{ headers: { Authorization: `Bearer ${token || signupToken}` } }
			)

			if (res.status == 200) {
				callback && thunkAPI.dispatch(callback())
				return res.data
			}
			return utils.rejectWithValue(thunkAPI, null, {
				message: res.data.message,
				status: res.status,
			})
		} catch (err) {
			return utils.rejectWithValue(thunkAPI, err)
		}
	}
)
export const sendFeedback = createAsyncThunk('info/sendFeedback', async (feedback, thunkAPI) => {
	try {
		const { user, token } = utils.getAuth(thunkAPI.getState())
		if (!token) {
			return thunkAPI.rejectWithValue({ data: { message: 'Null token' } })
		}
		const res = await axios.post(
			`/merchant/feedback`,
			{ ...feedback, id: user.id },
			{ headers: { Authorization: `Bearer ${token}` } }
		)
		if (res.status == 200) {
			return res.data
		}
		return utils.rejectWithValue(thunkAPI, null, {
			message: res.data.message,
			status: res.status,
		})
	} catch (err) {
		return utils.rejectWithValue(thunkAPI, err)
	}
})

export const slice = createSlice({
	name: 'info',
	initialState,
	reducers: {
		clearState: (state, { payload }) => utils.clearState(state, status, payload),
	},
	extraReducers: {
		/*
      Get Statistics
      */
		[getStatistics.fulfilled]: (state, { payload }) => {
			const { data, message } = payload

			utils.handleSuccess(state.status.getStatistics, { message: message, status: 200 })

			state.statistics = data
			return state
		},
		[getStatistics.rejected]: (state, { payload }) =>
			utils.handleError(state.status.getStatistics, payload?.data),
		[getStatistics.pending]: state => utils.handleLoading(state.status.getStatistics),

		/*
     Get Business Info
      */
		[getBusinessInfo.fulfilled]: (state, { payload }) => {
			const { data, message } = payload

			state.businessInfo = {
				...state.businessInfo,
				...data,
				...(data.coordinates && { coordinates: JSON.parse(data.coordinates) }),
				// ...(data.businessPhotos && { coordinates: JSON.parse(data.businessPhotos) }),
				// ...(data.hours && { hours: JSON.parse(data.hours) }),
			}

			utils.handleSuccess(state.status.getBusinessInfo, { message: message, status: 200 })

			return state
		},

		[getBusinessInfo.rejected]: (state, { payload }) =>
			utils.handleError(state.status.getBusinessInfo, payload?.data),
		[getBusinessInfo.pending]: state => utils.handleLoading(state.status.getBusinessInfo),

		/*
     Update Business Info
      */
		[updateBusinessInfo.fulfilled]: (state, { payload }) => {
			const { data, message } = payload
			// const {message} = payload.data
			utils.handleSuccess(state.status.updateBusinessInfo, { message: message, status: 200 })

			return state
		},
		[updateBusinessInfo.rejected]: (state, { payload }) =>
			utils.handleError(state.status.updateBusinessInfo, payload?.data),
		[updateBusinessInfo.pending]: state =>
			utils.handleLoading(state.status.updateBusinessInfo, 'Updating...'),
		/*
      Get Locations
      */
		[getLocations.fulfilled]: (state, { payload }) => {
			const { data, message } = payload
			state.locations = data
			utils.handleSuccess(state.status.getLocations, message)

			return state
		},
		[getLocations.rejected]: (state, { payload }) =>
			utils.handleError(state.status.getLocations, payload?.data),
		[getLocations.pending]: state => utils.handleLoading(state.status.getLocations),

		/*
      Update Default Location
      */
		[updateDefaultLocation.fulfilled]: (state, { payload }) => {
			const { data, message } = payload
			utils.handleSuccess(state.status.updateDefaultLocation, {
				message: message,
				status: 200,
			})

			return state
		},
		[updateDefaultLocation.rejected]: (state, { payload }) =>
			utils.handleError(state.status.updateDefaultLocation, payload?.data),
		[updateDefaultLocation.pending]: state =>
			utils.handleLoading(state.status.updateDefaultLocation),

		/*
      	Get Counts
      */
		[getCounts.fulfilled]: (state, { payload }) => {
			const { data, message } = payload
			state.counts = data
			utils.handleSuccess(state.status.getCounts, { message: message, status: 200 })

			return state
		},
		[getCounts.rejected]: (state, { payload }) =>
			utils.handleError(state.status.getCounts, payload?.data),
		[getCounts.pending]: state => utils.handleLoading(state.status.getCounts),

		/*
      	Get Counts
      */
		[getPaymentLink.fulfilled]: (state, { payload }) => {
			const { data } = payload
			const { url, completed } = data
			state.paymentLink = url
			state.bankingCompleted = completed

			utils.handleSuccess(state.status.getPaymentLink, {
				message: 'Payment link fetched',
				status: 200,
			})

			return state
		},
		[getPaymentLink.rejected]: (state, { payload }) =>
			utils.handleError(state.status.getPaymentLink, payload?.data),
		[getPaymentLink.pending]: state => utils.handleLoading(state.status.getPaymentLink),

		/*
      Set Payment Link
      */
		[setPaymentLink.fulfilled]: (state, { payload }) => {
			const { data, message } = payload
			const { url } = data
			state.paymentLink = url
			utils.handleSuccess(state.status.setPaymentLink, { message: message, status: 200 })

			return state
		},
		[setPaymentLink.rejected]: (state, { payload }) =>
			utils.handleError(state.status.setPaymentLink, payload?.data),
		[setPaymentLink.pending]: state => utils.handleLoading(state.status.setPaymentLink),

		/*
      Send Feedback 
      */
		[sendFeedback.fulfilled]: (state, { payload }) => {
			const { data, message } = payload

			utils.handleSuccess(state.status.sendFeedback, { message, status: 200 })

			return state
		},
		[sendFeedback.rejected]: (state, { payload }) =>
			utils.handleError(state.status.sendFeedback, payload?.data),
		[sendFeedback.pending]: state => utils.handleLoading(state.status.sendFeedback),
	},
})
export const { clearState } = slice.actions
export default slice.reducer
